<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6">
        <h2>{{ $t('entities.Order.Singular') }} {{ customer }}</h2>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.name') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="customer" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.orderNumber') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="orderNumber" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.complete') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-checkbox
              :disabled="true"
              v-model="complete" />
          </div>
        </div>
        <div v-if="!complete"
             class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('payment.remaining') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="amount" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.productTypeId') }}:</label>
          </div>
          <div class="col-lg-9">
            <ProductTypeInput
              :editable="false"
              v-model="productTypeId" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.created') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="createdFormatted" />
          </div>
        </div>
      </div>
      <div class="col-lg-6"
           v-if="moneyVouchers.length > 0 || productVoucher !== null">
        <h4>{{ $t('orders.RedeemedVouchers') }}</h4>
        <div v-if="moneyVouchers.length > 0"
             class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('entities.MoneyVoucher.Plural') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-textarea
              v-model="moneyVouchers"
              class="myInput"
              :editable="false"
              no-resize
              rows="2" />
          </div>
        </div>
        <div v-if="productVoucher !== null"
             class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('entities.ProductVoucher.Plural') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-textarea
              v-model="productVoucher"
              class="myInput"
              :editable="false"
              no-resize
              rows="1" />
          </div>
        </div>
      </div>
      <div class="col-lg-6"
           v-if="cardPayment !== null || cashPayment !== null || bankTransferPayment !== null">
        <div v-if="cashPayment !== null">
          <h4>{{ $t('payment.cashPayment') }}</h4>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.receivedByUser') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="cashPayment.receivedByUser" />
          </div>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.receivedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="cashPaymentReceivedAtFormatted" />
          </div>
        </div>
        <div v-if="cardPayment !== null">
          <h4>{{ $t('payment.cardPayment') }}</h4>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.transactionId') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="cardPayment.transactionId" />
          </div>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.refId') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="cardPayment.refId" />
          </div>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.status') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              :value="$t('payment.cardStatus.'+cardPayment.status)" />
          </div>
          <div v-if="cardPayment.status === 3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.receivedAt') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                v-model="cardPaymentReceivedAtFormatted" />
            </div>
          </div>
        </div>
        <div v-if="bankTransferPayment !== null">
          <h4>{{ $t('payment.bankTransferPayment') }}</h4>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.variableSymbol') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="bankTransferPayment.variableSymbol" />
          </div>
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.complete') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              :value="$t('common.'+bankTransferPayment.complete)" />
          </div>
          <div v-if="bankTransferPayment.complete">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.account') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                v-model="bankTransferPayment.account" />
            </div>
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.receivedAt') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                :value="bankTransferPaymentReceivedAtFormatted" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import ProductTypeInput from '@components/input/ProductTypeInput';

export default {
  name: 'OrderViewDetail',
  components: {
    ProductTypeInput
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    createdFormatted() {
      return this.$moment(this.created).format('DD.MM.YYYY HH:mm:ss');
    },
    cashPaymentReceivedAtFormatted() {
      return this.$moment(this.cashPayment.receivedAt || '').format('DD.MM.YYYY HH:mm:ss');
    },
    cardPaymentReceivedAtFormatted() {
      return this.$moment(this.cardPayment.receivedAt || '').format('DD.MM.YYYY HH:mm:ss');
    },
    bankTransferPaymentReceivedAtFormatted() {
      return this.$moment(this.bankTransferPayment.receivedAt || '').format('DD.MM.YYYY HH:mm:ss');
    },
    productTypeId: {
      get() {
        return this.$store.state.orderViewDetail.productTypeId;
      },
      set() {
      }
    },
    ...mapState('orderViewDetail', ['customer', 'orderNumber', 'complete', 'created', 'moneyVouchers', 'productVoucher', 'cashPayment', 'cardPayment', 'bankTransferPayment', 'amount']),
  },
  created() {
    this.setOrderId(this.id);
    this.fetchOrder()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchOrder: 'orderViewDetail/fetchOrder', resetContext: 'orderViewDetail/resetContext' }),
    ...mapMutations({ setOrderId: 'orderViewDetail/setOrderId' })
  }
};
</script>
<style lang="scss" scoped>
</style>
